import * as React from "react"
import PropTypes from "prop-types"

import Header from "./header"
import Footer from "./footer"

import { configure } from "mobx"
import useHotjar from "react-use-hotjar"

configure({ useProxies: "never" }) // Or "ifavailable".

function Layout(props) {
  return (
    <div style={{ width: "100%" }}>
      <Header
        hideCountrySwitcher={props.hideCountrySwitcher}
        countryCode={props.countryCode}
      />
      <main>{props.children}</main>
      <Footer countryCode={props.countryCode} />
    </div>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired
}

export default Layout
